export const SERVER_ORIGIN = `${window.location.protocol}//${window.location.hostname}${window.location.protocol === "http:" ? ":8080" : ""}`;

export const ROLES = {
  student: "STUDENT",
  teacher: "TEACHER",
};

export const INTERACTION_TYPES = {
  individual: "INDIVIDUAL",
  group: "GROUP",
};

export const GROUP_TABS = {
  overview: "overview",
  materials: "materials",
  stats: "stats",
};

export const GROUP_TABS_LIST = [
  { key: GROUP_TABS.overview, label: "Обзор" },
  { key: GROUP_TABS.materials, label: "Материалы и работы" },
  { key: GROUP_TABS.stats, label: "Статистика" },
];

export const TOKEN_KEY = "token";

export const USER_DETAILS_KEY = "userDetails";

export const STATUSES = {
  open: "OPEN",
  closed: "CLOSED",
  upcoming: "UPCOMING",
  draft: "DRAFT",
};

export const COMMENT_POLICY_ENUM = {
  required: "REQUIRED",
  optional: "OPTIONAL",
  forbidden: "FORBIDDEN",
};

export const REVIEW_STATUS_ENUM = {
  notSubmitted: "NOT_SUBMITTED",
  onReview: "ON_REVIEW",
  rework: "REWORK",
  passed: "PASSED",
  failed: "FAILED",
};

export const ATTACHMENT_KIND_ENUM = {
  code: "CODE",
  report: "REPORT",
};

export const ATTACHMENT_ACTIONS_ENUM = {
  upload: "UPLOAD",
  addVersion: "ADD_VERSION",
  delete: "DELETE",
};
